import React from 'react';

import YouTube from 'react-youtube';
import styled from 'styled-components';

const Container = styled.div`
  display: block;
  max-width: 920px;
  overflow: hidden;
  margin: 2.5rem auto;
  ${Styles.mobile`
    margin: 1.5rem auto;
  `}
`;

const YoutubeContainer = styled.div`
  position: relative;
  padding-bottom: 56.25%;
  padding-top: 30px;
  height: 0;
  overflow: hidden;

  & iframe,
  & object,
  & embed {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

const VideoWidget = ({ videoId, videoAutoplay = false }) => {
  const opts = {
    playerVars: {
      autoplay: videoAutoplay ? 1 : 0,
      mute: videoAutoplay ? 1 : 0,
    },
  };

  return (
    <Container>
      <YoutubeContainer>
        <YouTube videoId={videoId} opts={opts} />
      </YoutubeContainer>
    </Container>
  );
};

export default VideoWidget;
